module.exports = __webpack_public_path__ + "static/mugshot-18e86de165b6e81e0de1d7a7caa7ff3d.jpg";